import { render } from "./VFullNameComponent.vue?vue&type=template&id=cb32eede"
import script from "./VFullNameComponent.vue?vue&type=script&lang=js"
export * from "./VFullNameComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__